import {
  AccordionItem,
  Text,
  List,
  Stack,
  Heading,
  Strong,
} from 'braid-design-system';
export const SectionG = () => (
  <AccordionItem id="section-g" label="Section G: ATS Questions">
    <Stack space="gutter">
      <Heading level="4">Functional</Heading>
      <List type="number" start={92}>
        <Text>
          Section G applies if you have chosen to use ATS Questions
          functionality through the SEEK API.
        </Text>
        <Text>
          <Strong>ATS Questions</Strong> means questionnaire creation using
          questions from your Recruitment Software in the structure expected by
          the SEEK API, which returns an ID that can be specified when posting a
          job ad.
        </Text>
        <Text>
          You acknowledge and agree that any questions created as part of the
          advertisement creation that are not selected from our existing library
          of questions must adhere to applicable Privacy Laws and these Terms.
        </Text>
      </List>
      <Heading level="4">Messaging / Branding</Heading>
      <List type="number" start={95}>
        <Text>
          Upon successfully integrating the ATS Questions into the partner
          system, we will review the implementation to ensure the design
          appropriately represents our brand and value proposition. We may
          decide to end your integration with the SEEK API if it determines, in
          our sole discretion, that the design implemented by you does not
          appropriately represent our brand and value proposition.
        </Text>
      </List>
    </Stack>
  </AccordionItem>
);
